<template>
  <v-card>
    <v-form ref="form_internaly" v-on:submit.prevent>
      <v-card-text>
        <v-container fluid class="pa-2 pa-sm-4">
          <freeplaces
            v-if="comp_open_Popup"
            :shootingrange_id="newShootingBook.ClubRange.id"
            :retain-focus="false"
            @close-dialog="closeDialog" />

          <!-- Verein, Stand & Bahn Section - ZUSAMMEN -->
          <v-card outlined class="mb-4">
            <v-card-subtitle class="pb-2">Standort</v-card-subtitle>
            <v-card-text>
              <v-select
                v-if="comp_meine_Vereine && comp_meine_Vereine.length > 0"
                v-model="newShootingBook.Verein"
                :items="comp_meine_Vereine"
                item-text="name"
                item-value="id"
                label="Verein"
                value=""
                return-object
                outlined
                dense
                hide-details="auto"
                class="mb-3"
                :retain-focus="false"
                @change="verein_select"
                :rules="[rules.required]"
                :error-messages="errorMessages"
              >
              </v-select>

              <v-select
                v-if="comp_selected_Shootingranges && comp_selected_Shootingranges.length > 0"
                v-model="comp_OpenShootingBookData_defaultClubRanges"
                :items="comp_selected_Shootingranges"
                item-text="LangBez"
                item-value="id"
                label="Stand"
                value=""
                return-object
                no-data-text="Kein Stand auswählbar - zuerst Verein wählen!"
                outlined
                dense
                hide-details="auto"
                class="mb-3"
                :disabled="disabledSelectsSL"
                :rules="[rules.dynamicValidation_User_SA()]"
                :error-messages="errorMessages"
              >
              </v-select>

              <v-text-field
                v-model="newShootingBook.Place"
                label="Bahn"
                @click="comp_open_Popup = true"
                outlined
                dense
                hide-details="auto"
                :disabled="disabledSelects"
              ></v-text-field>
            </v-card-text>
          </v-card>

          <!-- Aktivität & Funktion Section - ZUERST -->
          <v-card outlined class="mb-4">
            <v-card-subtitle class="pb-2">Aktivität & Funktion</v-card-subtitle>
            <v-card-text>
              <v-select
                v-if="comp_Shootingbook_Action && comp_Shootingbook_Action.length > 0"
                v-model="newShootingBook.shootingAction"
                :items="comp_Shootingbook_Action"
                item-text="function"
                item-value="value"
                label="Funktion"
                value=""
                @change="set_Options"
                return-object
                outlined
                dense
                class="mb-3"
                hide-details="auto"
              >
              </v-select>

              <v-select
                v-if="comp_OpenShootingBookData_Trainingart && comp_OpenShootingBookData_Trainingart.length > 0"
                v-model="newShootingBook.aktivitaet"
                :items="comp_OpenShootingBookData_Trainingart"
                item-text="aktivitaet"
                item-value="id"
                label="Aktivität"
                value=""
                return-object
                outlined
                dense
                hide-details="auto"
                :disabled="disabledSelects"
              >
              </v-select>
            </v-card-text>
          </v-card>

          <!-- Waffe, Disziplin & Zeit Section - ZUSAMMEN -->
          <v-card outlined class="mb-4">
            <v-card-subtitle class="pb-2">Waffe, Disziplin & Zeitpunkt</v-card-subtitle>
            <v-card-text>
              <v-tabs v-model="weaponTab" dense grow class="mb-3">
                <v-tab class="text-none">Meine Waffen</v-tab>
                <v-tab v-if="comp_selected_verein_has_weaponpool" class="text-none">Waffenpool 🎯</v-tab>
              </v-tabs>

              <v-tabs-items v-model="weaponTab">
                <v-tab-item>
                  <v-select
                    v-if="comp_OpenShootingBookData_OwnWeapons && comp_OpenShootingBookData_OwnWeapons.length > 0"
                    v-model="newShootingBook.OwnWeapon"
                    :items="comp_OpenShootingBookData_OwnWeapons"
                    item-text="KurzT"
                    item-value="id"
                    label="Eigene Waffe"
                    value=""
                    return-object
                    outlined
                    dense
                    hide-details="auto"
                    class="mb-3 weapon-dropdown-spacing"
                    :disabled="disabledSelects"
                  >
                  </v-select>
                  <v-alert
                    v-else
                    type="info"
                    dense
                    text
                    class="mt-2 mb-2"
                  >
                    Du hast noch keine eigenen Waffen hinterlegt.
                    <template v-if="comp_selected_verein_has_weaponpool">
                      Bitte wechsle zum Tab <strong>Waffenpool</strong>, um eine Vereinswaffe zu nutzen.
                    </template>
                    <template v-else>
                      Gehe zu <a href="/user/weapon">Meine Waffen</a>, um eine Waffe hinzuzufügen.
                    </template>
                  </v-alert>
                </v-tab-item>
                <v-tab-item>
                  <v-select
                    v-if="comp_weaponPool && comp_weaponPool.length > 0"
                    v-model="selectedPoolWeapon"
                    :items="comp_weaponPool"
                    item-text="id"
                    item-value="id"
                    label="Pool-Waffe auswählen"
                    return-object
                    outlined
                    dense
                    hide-details="auto"
                    class="mb-3 weapon-dropdown-spacing"
                    :disabled="disabledSelects"
                  >
                    <template slot="selection" slot-scope="data">
                      <div v-if="data.item && data.item.weapon" class="d-flex flex-column py-1 pool-weapon-selection">
                        <span class="font-weight-medium text-truncate">
                          {{ data.item.weapon.hersteller }} {{ data.item.weapon.kurz_bezeichnung }}
                        </span>
                        <span class="text-caption grey--text text--darken-2 text-truncate">
                          <v-icon x-small>{{ data.item.owner_type === 'club' ? 'mdi-domain' : 'mdi-account' }}</v-icon>
                          {{ data.item.owner_name }}
                        </span>
                      </div>
                    </template>
                    <template slot="item" slot-scope="data">
                      <v-list-item-content v-if="data.item && data.item.weapon">
                        <v-list-item-title>{{ data.item.weapon.hersteller }} {{ data.item.weapon.kurz_bezeichnung }}</v-list-item-title>
                        <v-list-item-subtitle>
                          {{ data.item.weapon.kaliber }} - 
                          <v-icon x-small>{{ data.item.owner_type === 'club' ? 'mdi-domain' : 'mdi-account' }}</v-icon>
                          {{ data.item.owner_name }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-select>
                </v-tab-item>
              </v-tabs-items>

              <v-alert
                v-if="comp_show_discipline_fallback_hint"
                type="warning"
                dense
                text
                class="mb-3"
              >
                <template v-if="weaponTab === 0">
                  Keine Disziplin an dieser Waffe hinterlegt — bitte manuell wählen
                  oder unter <a href="/user/weapon">Meine Waffen</a> ergänzen.
                </template>
                <template v-else>
                  Dieser Pool-Waffe ist keine Disziplin zugeordnet — bitte manuell wählen.
                </template>
              </v-alert>

              <DisciplinePicker
                v-if="comp_show_weapon_details"
                v-model="newShootingBook.Disziplin"
                :weapon-items="comp_weapon_disciplines_sorted"
                :all-items="comp_all_disciplines"
                class="mb-3"
                :disabled="disabledSelects"
                :rules="[v => disabledSelects || (v && Object.keys(v).length > 0) || 'Pflichtfeld.']"
                :error-messages="errorMessages"
              />

              <v-datetime-picker
                v-if="newShootingBook && comp_show_weapon_details"
                label="Begin"
                date-format="dd.MM.yyyy"
                time-format="HH:mm"
                v-model="newShootingBook.Begin"
                :text-field-props="textFieldPropsCustom"
                :time-picker-props="timePickerProps"
                :date-picker-props="datePickerProps"
                :retain-focus="false"
              >
                <template slot="dateIcon">
                  <v-icon>mdi-calendar</v-icon>
                </template>
                <template slot="timeIcon">
                  <v-icon>mdi-clock-outline</v-icon>
                </template>
              </v-datetime-picker>
            </v-card-text>
          </v-card>
        </v-container>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="px-4 py-3">
        <v-spacer></v-spacer>
        <v-btn
          color="success"
          block
          large
          @click="save()"
        >
          <v-icon left>far fa-save</v-icon>
          Sichern
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import freeplaces from "@/views/component/freeplaces.vue";
import DisciplinePicker from "@/views/component/DisciplinePicker.vue";
import { sortDisciplines } from "@/views/component/disciplineUtils";

export default {
  name: "recordshootingtime_form_internaly",
  components: { freeplaces, DisciplinePicker },
  data: () => ({
    disabledSelects: false,
    disabledSelectsSL: false,
    newShootingBook: {
        shootingAction: { function: "Schütze", value: 1 },
        aktivitaet: { id: 1 },
        ClubRange: {},
        OwnWeapon: {},
        Disziplin: {},
        Begin: new Date(),
        Place: null,
        Verein: null
      },
    WeaponDiszi: [],
    textFieldProps: {
      outlined: true
    },
    textFieldPropsCustom: {
      outlined: true,
      dense: true,
      hideDetails: "auto"
    },
    datePickerProps: {},
    timePickerProps: {
      format: "24hr"
    },
    signature_style: { border: "black 3px solid" },
    rules: {
      required: value => !!value || "Pflichtfeld.",
      dynamicValidation_User_SA(value) {
        const shootingActionValue = this.newShootingBook?.shootingAction?.value;
        if (shootingActionValue === 1 || shootingActionValue === 2) {
          return value && Object.keys(value).length > 0 ? true : "Feld darf nicht leer sein.";
        }
        // Andere Funktionen benötigen keine Validierung
        return true;
      },
      dynamicValidation_User(value) {
        const shootingActionValue = this.newShootingBook?.shootingAction?.value;
        if (shootingActionValue === 1) {
          return value && Object.keys(value).length > 0 ? true : "Feld darf nicht leer sein.";
        }
        // Andere Funktionen benötigen keine Validierung
        return true;
      }
    },
    formHasErrors: false,
    errorMessages: "",
    weaponTab: 0,
    selectedPoolWeapon: null,
    poolWeaponDisciplines: [],
    poolDisciplinesLoading: false,
    poolDisciplinesRequest: 0
  }),
  computed: {
    comp_OpenShootingBookData_Club_DefaultClub() {
      const state = this.$store.state.UserApp.OpenShootingBookData;
      var data = false;
      if (state != null && Object.keys(state).length > 0) {
        data = state.Club.Vereinsnummer === "99999";
      }
      return data;
    },
    comp_OpenShootingBookData_defaultClubRanges: {
      get() {
        const data = this.$store.state.UserApp.OpenShootingBookData;
        if (data && data.ClubRanges && Array.isArray(data.ClubRanges) && data.ClubRanges.length > 0) {
          return data.ClubRanges[0];
        }
        return null;
      },
      set(val) {
        if (val) {
          this.newShootingBook.ClubRange = val;
        }
      }
    },
    comp_open_Popup: {
      get() {
        return this.$store.getters["UserApp/is_open_popup_freeplaces"];
      },
      set(val) {
        this.$store.dispatch("UserApp/set_recordshootingTime_Freeplaces_PopUp", val);
      }
    },

    comp_selected_Shootingranges() {
      return this.$store.getters["UserApp/has_selected_ShootingRanges"] || [];
    },

    comp_OpenShootingBookData_OwnWeapons() {
      return this.$store.state.UserApp.Weapons || [];
    },
    comp_OpenShootingBookData_CountOwnWeapons() {
      return this.comp_OpenShootingBookData_OwnWeapons.length;
    },
    comp_OpenShootingBookData_Trainingart() {
      const data = this.$store.state.UserApp.OpenShootingBookData;
      return (data && data.trainingart) ? data.trainingart : [];
    },
    comp_selected_weapon_id() {
      return this.weaponTab === 0
        ? (this.newShootingBook?.OwnWeapon?.id || null)
        : (this.selectedPoolWeapon ? this.selectedPoolWeapon.weapon_id : null);
    },
    // Eigene Waffen bringen ihre Disziplinen in UserApp.Weapons mit, Poolwaffen werden nachgeladen
    comp_weapon_disciplines_sorted() {
      const list = this.weaponTab === 0
        ? this.$store.getters["UserApp/weapon_Disciplines"](this.comp_selected_weapon_id)
        : this.poolWeaponDisciplines;
      return sortDisciplines(list);
    },
    comp_selected_weapon_has_disciplines() {
      return this.comp_weapon_disciplines_sorted.length > 0;
    },
    comp_all_disciplines() {
      return this.$store.state.UserApp.Discipline || [];
    },
    comp_show_discipline_fallback_hint() {
      return this.comp_show_weapon_details
        && !!this.comp_selected_weapon_id
        && !this.comp_selected_weapon_has_disciplines
        && !this.disabledSelects
        && !this.poolDisciplinesLoading;
    },
    comp_weaponPool() {
      return this.$store.getters["UserApp/weaponPool"] || [];
    },
    comp_Shootingbook_Action() {
      const data = this.$store.state.UserApp.OpenShootingBookData;
      if (data && data.shooting_functions && Array.isArray(data.shooting_functions) && data.shooting_functions.length > 0) {
        return data.shooting_functions.map(f => ({
          function: f.shooting_function_name || f.name || f.funktion_name,
          value: f.id || f.shooting_function_id,
          id: f.id || f.shooting_function_id
        }));
      }

      // Fallback auf statische Liste, falls API (noch) nichts liefert
      return [
        { function: "Schütze", value: 1, id: 1 },
        { function: "Standaufsicht", value: 2, id: 2 },
        { function: "Schießsportleiter", value: 3, id: 3 }
      ].filter(item => {
        if (item.value === 1) return true;
        const hasEdu = this.$store.getters["UserApp/has_Education_Supervision"];
        return typeof hasEdu !== "undefined" && hasEdu === true;
      });
    },
    comp_meine_Vereine() {
      const clubs = this.$store.state.UserApp.Clubs;
      if (clubs && clubs.meineVereine) {
        return clubs.meineVereine;
      }
      return [];
    },
    comp_default_Verein() {
      const clubs = this.$store.state.UserApp.Clubs;
      if (clubs && clubs.defVerein && Array.isArray(clubs.defVerein) && clubs.defVerein.length > 0) {
        const defId = clubs.defVerein[0].defaultVerein;
        return this.comp_meine_Vereine.find(v => v.id === defId) || null;
      }
      return null;
    },
    comp_selected_verein_has_weaponpool() {
      return this.newShootingBook.Verein && this.newShootingBook.Verein.has_weapon_pool === true;
    },
    comp_show_weapon_details() {
      // Disziplin & Beginn nur anzeigen wenn eine Waffe auswählbar ist:
      // Tab "Meine Waffen" nur wenn eigene Waffen vorhanden, Tab "Waffenpool" immer
      if (this.weaponTab === 1) return true;
      return this.comp_OpenShootingBookData_OwnWeapons.length > 0;
    }
  },

  beforeMount() {
    this.initData();
  },

  created() {
    this.$store.dispatch("UserApp/ensureDisciplines");

    // Initialisiere Verein mit der Default-Einstellung
    this.newShootingBook.Verein = this.comp_default_Verein || null;
    this.verein_select();

    // Pool-Waffen laden
    if (this.comp_selected_verein_has_weaponpool) {
      this.$store.dispatch("UserApp/fetchPoolWeapons");
    }

    // Automatisch Pool-Tab aktivieren wenn keine eigenen Waffen vorhanden
    if (this.comp_OpenShootingBookData_CountOwnWeapons === 0 && this.comp_selected_verein_has_weaponpool) {
      this.weaponTab = 1;
    }

    // Check query params for pool weapon
    if (this.$route.query.is_from_pool || this.$route.query.weapon_pool_id) {
      this.weaponTab = 1;
    }
  },

  watch: {
    weaponTab() {
      this.applyDefaultDisziplin();
    },
    'newShootingBook.OwnWeapon'() {
      if (this.weaponTab === 0) {
        this.applyDefaultDisziplin();
      }
    },
    selectedPoolWeapon() {
      this.loadPoolWeaponDisciplines();
    },
    '$route.query.weapon_pool_id': {
      immediate: true,
      handler(val) {
        if (val) {
          this.weaponTab = 1;
          this.checkAndSelectPoolWeapon(val);
        }
      }
    },
    comp_weaponPool(val) {
      if (this.$route.query.weapon_pool_id && val.length > 0) {
        this.checkAndSelectPoolWeapon(this.$route.query.weapon_pool_id);
      }
    }
  },

  methods: {
    checkAndSelectPoolWeapon(weaponPoolId) {
      if (weaponPoolId && this.comp_weaponPool.length > 0) {
        const poolWeapon = this.comp_weaponPool.find(w => w.id === parseInt(weaponPoolId));
        if (poolWeapon) {
          this.selectedPoolWeapon = poolWeapon;
        }
      }
    },
    initData() {
      if (!this.comp_OpenShootingBookData_Club_DefaultClub && this.comp_OpenShootingBookData_CountOwnWeapons > 0) {
        this.newShootingBook.OwnWeapon = this.$store.state.UserApp.Weapons[0];
        this.newShootingBook.ClubRange = {};
        this.$store.dispatch("UserApp/set_SelectedShootingRanges_to_Default");
      }
    },

    async save() {
      if (!this.newShootingBook.Verein) {
        this.errorMessages = "Verein ist ein Pflichtfeld!";
        return;
      }

      if (this.$refs.form_internaly.validate()) {

        var Data;
        switch (this.newShootingBook.shootingAction.value) {
          case 1:

            if (
              Object.keys(this.newShootingBook.Disziplin).length === 0 ||
              Object.keys(this.newShootingBook.ClubRange).length === 0 ||
              Object.keys(this.newShootingBook.Verein).length === 0
            ) {
              this.errorMessages = "Pflichtfelder ausfüllen!";
              return;
            }

            Data = {
              inputVereinID: this.newShootingBook.Verein.id,
              inputStand: this.newShootingBook.ClubRange.id,
              inputTrainingArt: this.newShootingBook.aktivitaet.id,
              inputDisz: this.newShootingBook.Disziplin.id,
              inputWaffe: this.weaponTab === 0 ? this.newShootingBook.OwnWeapon.id : (this.selectedPoolWeapon ? this.selectedPoolWeapon.weapon_id : null),
              is_from_pool: this.weaponTab === 1,
              weapon_pool_id: this.weaponTab === 1 && this.selectedPoolWeapon ? this.selectedPoolWeapon.id : null,
              inputPlatz: this.newShootingBook.Place,
              inputSA: this.newShootingBook.shootingAction.value,
              inputBegin: this.newShootingBook.Begin
            };
            break;
          case 2:

            if (
              Object.keys(this.newShootingBook.ClubRange).length === 0 ||
              Object.keys(this.newShootingBook.Verein).length === 0
            ) {
              this.errorMessages = "Pflichtfelder ausfüllen!";
              return;
            }

            Data = {
              inputVereinID: this.newShootingBook.Verein.id,
              inputStand: this.newShootingBook.ClubRange.id,
              inputSA: this.newShootingBook.shootingAction.value,
              inputBegin: this.newShootingBook.Begin
            };
            break;
          case 3:
          case 4:

            if (Object.keys(this.newShootingBook.Verein).length === 0) {
              this.errorMessages = "Pflichtfelder ausfüllen!";
              return;
            }

            Data = {
              inputVereinID: this.newShootingBook.Verein.id,
              inputSA: this.newShootingBook.shootingAction.value,
              inputBegin: this.newShootingBook.Begin
            };
            break;
        }

        await this.$store.dispatch("UserApp/setNewShootingBookRecord", Data)
          .then(this.set_defaultInputs());

      }
    },
    set_Options() {
      switch (this.newShootingBook.shootingAction.value) {
        case 1:
          this.disabledSelects = false;
          this.disabledSelectsSL = false;
          break;
        case 2:
          this.disabledSelects = true;
          this.disabledSelectsSL = false;
          break;
        case 3:
        case 4:
          this.disabledSelects = true;
          this.disabledSelectsSL = true;
          break;
      }
    },
    async set_defaultInputs() {
      this.newShootingBook = {
        shootingAction: { function: "Schütze", value: 1 },
        aktivitaet: { id: 1 },
        ClubRange: {},
        OwnWeapon: this.$store.state.UserApp.Weapons[0],
        Disziplin: {},
        Begin: new Date(),
        Place: null,
        Verein: this.comp_default_Verein || null
      };
      this.$store.dispatch("UserApp/set_SelectedShootingRanges_to_Default");
      await this.verein_select();
    },

    async verein_select() {
      if (!this.newShootingBook.Verein || !this.newShootingBook.Verein.id) {
        return;
      }
      const Data = {
        club_id: this.newShootingBook.Verein.id
      };
      await this.$store.dispatch("UserApp/getSelectedShootingRanges", Data);

      // Pool-Waffen für diesen Verein laden
      if (this.comp_selected_verein_has_weaponpool) {
        await this.$store.dispatch("UserApp/fetchPoolWeapons", { verein_id: this.newShootingBook.Verein.id });
        // Automatisch Pool-Tab aktivieren wenn keine eigenen Waffen vorhanden
        if (this.comp_OpenShootingBookData_CountOwnWeapons === 0) {
          this.weaponTab = 1;
        }
      } else {
        this.$store.commit("UserApp/SET_WEAPON_POOL", []);
        this.weaponTab = 0;
        this.selectedPoolWeapon = null;
      }

      const ranges = this.comp_selected_Shootingranges;
      if (ranges && ranges.length > 0) {
        this.newShootingBook.ClubRange = ranges[0];
      } else {
        this.newShootingBook.ClubRange = {};
      }

      this.applyDefaultDisziplin();
    },

    // Disziplinen der Poolwaffe nachladen – der Getter weapon_Disciplines kennt nur eigene Waffen
    async loadPoolWeaponDisciplines() {
      const weaponId = this.selectedPoolWeapon ? this.selectedPoolWeapon.weapon_id : null;
      const request = ++this.poolDisciplinesRequest;
      this.poolDisciplinesLoading = !!weaponId;
      let list = [];
      if (weaponId) {
        try {
          list = await this.$store.dispatch("UserApp/fetchWeaponDisciplines", weaponId);
        } catch (error) {
          list = [];
        }
      }
      // Eine ältere, langsamere Antwort darf die zur neu gewählten Waffe nicht überschreiben
      if (request !== this.poolDisciplinesRequest) return;
      this.poolWeaponDisciplines = list;
      this.poolDisciplinesLoading = false;
      if (this.weaponTab === 1) {
        this.applyDefaultDisziplin();
      }
    },

    // Vorbelegt wird nur aus den Disziplinen der Waffe – nie irgendeine aus dem Gesamtkatalog
    applyDefaultDisziplin() {
      this.newShootingBook.Disziplin = this.comp_selected_weapon_has_disciplines
        ? this.comp_weapon_disciplines_sorted[0]
        : {};
    },

    closeDialog(place) {
      this.comp_open_Popup = false;
      this.newShootingBook.Place = place;
    }
  }

};
</script>

<style scoped>
.weapon-dropdown-spacing {
  margin-top: 5px;
}
.pool-weapon-selection {
  min-width: 0;
  max-width: 100%;
  flex: 1 1 auto;
  line-height: 1.2;
}
.pool-weapon-selection > span {
  display: block;
  min-width: 0;
}
/* v-autocomplete: Suchfeld vertikal mittig zur 2-zeiligen Selection ausrichten */
::v-deep .v-select__slot input {
  align-self: center;
}
/* Mobile optimization */
@media (max-width: 600px) {
  .v-card__subtitle {
    font-size: 0.875rem;
    font-weight: 600;
  }
}
</style>